import { useQuery } from '@tanstack/react-query'
import {  fetchFunctionalSummaryGraph } from '../services/functional_summaries';

const GetFunctionalSummaryGraph = (
  patient,
  startDate = null,
  endDate = null,
  scores = null,
  providerIds = null,
  functionalIssues = null
) => {
  const functionalSummaryGraph = useQuery({
    queryKey: [
      'functional_summary_graph',
      patient,
      startDate,
      endDate,
      scores,
      providerIds,
      functionalIssues,
    ],
    queryFn: () =>
      fetchFunctionalSummaryGraph(
        patient,
        startDate,
        endDate,
        scores,
        providerIds,
        functionalIssues
      ),
    enabled: !!patient,
  });
  return functionalSummaryGraph;
}

export default GetFunctionalSummaryGraph